module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.4d3ab24.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Regular.otf
// module id = QCWU
// module chunks = 0